import api from '../../services/api';
export const getDashboard = async () => {

    const response = await api.get("/blog/admin/dashboard/");
    return response.data;
};


export const getPosts = async () => {

    const response = await api.get("/blog/admin/posts/");
    return response.data;
};





export const updatePost = async (id, formData) => {

    const response = await api.put(`/blog/admin/posts/${id}/`, formData);
    return response.data;
};